export { default as changeLocaleToSources } from './changeLocaleToSources'
export { default as customDetectorConfig } from './customDetectorConfig'
export { default as getCurrentLocaleFromSources } from './getCurrentLocaleFromSources'
